const configure = {
  // appUrl: "/",
  // appUrl: "/RX6T0QNRP6V2Y8YX3FFS/ ",
  // apiUrl: "https://api.zithas.com/api",
  // imgUrl: "https://api.zithas.com/application/public",   // Live
  // nodeApi: 'https://napi.zithas.com/api',
  // nodeUkApi: "https://napi.zithas.co.uk/api",
  // nodeImgApi: 'https://napi.zithas.com',
  // exchangeKey: "HBhbjhBY9Zui0q8XUT0O7BcuFgs9l5q5", 
  // hostingDomainOnlyId: 14,  
  // type: 2, // Earth

  // imgUrl: "https://mars.ztpl.net/application/public",
  // apiUrl: "https://mars.ztpl.net/api",                  // Ztpl

  appUrl: "/work-module/",
  apiUrl: "https://edemoapi.zithas.com/api",
  imgUrl: "https://edemoapi.zithas.com/application/public",    // demo Ztpl
  nodeApi: 'https://endemoapi.zithas.com/api',
  nodeUkApi: "https://dnapi.zithas.co.uk/api",
  nodeImgApi: 'https://endemoapi.zithas.com',
  exchangeKey: "M5CQtQbJko1A2CDN4tjHvF9qFTkgQIoG",  
  hostingDomainOnlyId: 30, 
 
  dashboardModule: 5
  // earth - 1 (default)
  // finance - 2
  // hr - 3
  // crm - 4 
}

export default configure